/* =========================================================
   1. SHOPPIFY PRICE SYNC: SAVINGS & DISCOUNTS
   Handles calculation of "Save X%" and "£XX.XX" on Product,
   Home, and Collection pages.
   ========================================================= */
function updateSavingsAndDiscountShopify() {
  const salePriceEl = document.querySelector('.price-item--sale.price-item--last');
  const regularPriceEl = document.querySelector('.cut_price .price-item--regular');
  const savingsEl = document.querySelector('.svm');
  const discountEl = document.querySelector('.pdisco');
  const savingsBox = document.querySelector('.price__total-savings');
  const discountBox = document.querySelector('.vp_save_percentage');

  if (!salePriceEl || !regularPriceEl || !savingsEl || !discountEl) return;

  const salePrice = parseFloat(salePriceEl.textContent.replace(/[^0-9.]/g, ''));
  const regularPrice = parseFloat(regularPriceEl.textContent.replace(/[^0-9.]/g, ''));

  if (!isNaN(salePrice) && !isNaN(regularPrice)) {
    if (regularPrice > salePrice) {
      const saving = regularPrice - salePrice;
      const discount = (saving / regularPrice) * 100;
      savingsEl.textContent = "£" + saving.toLocaleString(undefined, { minimumFractionDigits: 2 });
      discountEl.textContent = discount.toFixed(0) + "%";
      if (savingsBox) savingsBox.style.display = 'block';
      if (discountBox) discountBox.style.display = 'inline-block';
    } else {
      savingsEl.textContent = "£0.00";
      discountEl.textContent = "0%";
    }
  }
}

// Observe Price Changes on Product Page
const priceContainer = document.querySelector('#price-template--25748674969939__main');
if (priceContainer) {
  const observer = new MutationObserver(() => { setTimeout(updateSavingsAndDiscountShopify, 200); });
  observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  window.addEventListener('load', () => { setTimeout(updateSavingsAndDiscountShopify, 300); });
}

// Home Page Discount Labels
jQuery(document).ready(function ($) {
  $('.home-price').each(function () {
    var $container = $(this);
    var $price = $container.find('[data-product-type="price"]');
    var $compare = $container.find('[data-product-type="compare_at_price"]');
    if ($price.length && $compare.length) {
      var salePrice = parseFloat($price.text().replace(/[^0-9\.]/g, ''));
      var originalPrice = parseFloat($compare.text().replace(/[^0-9\.]/g, ''));
      if (originalPrice > salePrice) {
        var discount = Math.round(((originalPrice - salePrice) / originalPrice) * 100);
        $container.append('<div class="Saveprice">Save -' + discount + '%</div>');
      }
    }
  });
});

// Collection Page Discount Labels
jQuery(function($) {
  $('.product-collection .price').each(function() {
    var $price = $(this);
    var saleText = $price.find('span.price-item').first().text();
    var origText = $price.find('s.price-item').first().text();
    var sale = parseFloat(saleText.replace(/[,£$]/g, '').trim());
    var orig = parseFloat(origText.replace(/[,£$]/g, '').trim());
    if (isFinite(sale) && isFinite(orig) && orig > sale) {
      var pct = Math.round(((orig - sale) / orig) * 100);
      var $target = $price.find('.price--on-sale');
      if (!$target.length) $target = $price;
      $target.append('<div class="Saveprice">Save ' + pct + '%</div>');
    }
  });
});

/* =========================================================
   2. NOVUNA FINANCE: TABS & MOBILE ACCORDION
   Handles switching logic and smooth scrolling for Novuna.
   ========================================================= */
jQuery(document).ready(function ($) {
  const $tab = $('div[data-id="tab-novuma-finance"]');
  const $section = $('section#shopify-section-template--25748674969939__17537748945fdac544');
  function toggleSection() {
    if ($tab.hasClass('active-tab')) { $section.show(); } else { $section.hide(); }
  }
  toggleSection();
  if ($tab.length) {
    const observer = new MutationObserver(toggleSection);
    observer.observe($tab[0], { attributes: true, attributeFilter: ['class'] });
  }
});

// Mobile Novuna Accordion Toggle
jQuery(function($) {
  const target = document.querySelector('.accordion-item.numuna');
  if (!target) return;
  const observer = new MutationObserver(() => {
    if ($(target).hasClass('active')) {
      $('#shopify-section-template--25748674969939__17537748945fdac544').addClass('active').css('display', 'block');
    } else {
      $('#shopify-section-template--25748674969939__17537748945fdac544').removeClass('active').css('display', 'none');
    }
  });
  observer.observe(target, { attributes: true, attributeFilter: ['class'] });
});

// Novuna Smooth Scroll Logic (Desktop & Mobile)
(function () {
  const ACTIVATE_ID = 'tab-novuma-finance';
  const DEACTIVATE_IDS = ['tab-description','tab-assembly-service','tab-additional-information'];
  const LINK_SELECTOR = 'a[href="#tab-finance-options-desktop"]';
  const DESKTOP_ANCHOR_ID = 'tab-finance-options-desktop';
  const MOBILE_ANCHOR_ID = 'tab-finance-options-mobile';

  function isVisible(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function smoothScrollTo(el, hash) {
    if (!el) return;
    const header = document.querySelector('.site-header, .header, header');
    const offset = header ? header.getBoundingClientRect().height : 0;
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: y, behavior: 'smooth' });
    if (hash) history.replaceState(null, '', `#${hash}`);
  }

  function activateDesktop() {
    [...DEACTIVATE_IDS, ACTIVATE_ID].forEach(id => {
      document.querySelector(`.summary__title.tablinks[data-id="${id}"]`)?.classList.remove('active-tab');
      document.querySelector(`.dt-sc-tabs-content.rte[data-id="${id}"]`)?.classList.remove('tab-active-content');
    });
    document.querySelector(`.summary__title.tablinks[data-id="${ACTIVATE_ID}"]`)?.classList.add('active-tab');
    document.querySelector(`.dt-sc-tabs-content.rte[data-id="${ACTIVATE_ID}"]`)?.classList.add('tab-active-content');
  }

  function activateMobile() {
    const allIds = [...DEACTIVATE_IDS, ACTIVATE_ID];
    allIds.forEach(id => {
      const hdr = document.querySelector(`.accordion-header[data-id="${id}"]`);
      const cnt = document.getElementById(id);
      if (hdr) { hdr.classList.remove('active','is-open'); hdr.setAttribute('aria-expanded','false'); }
      if (cnt) { cnt.classList.remove('tab-active-content','open','is-open'); cnt.style.display = 'none'; }
    });
    const financeHdr = document.querySelector(`.accordion-header[data-id="${ACTIVATE_ID}"]`);
    const financeCnt = document.getElementById(ACTIVATE_ID);
    if (financeHdr) { financeHdr.classList.add('active','is-open'); financeHdr.setAttribute('aria-expanded','true'); }
    if (financeCnt) { financeCnt.classList.add('tab-active-content','open','is-open'); financeCnt.style.display = 'block'; }
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest(LINK_SELECTOR);
    if (!link) return;
    e.preventDefault();
    activateDesktop();
    activateMobile();
    setTimeout(() => {
      const target = document.getElementById(DESKTOP_ANCHOR_ID) || document.getElementById(MOBILE_ANCHOR_ID);
      smoothScrollTo(target, target.id);
    }, 300);
  });
})();

/* =========================================================
   3. POPUPS & MODALS: PAYPAL, KLARNA, CONTACT FORM
   Handles opening/closing and URL injection for all popups.
   ========================================================= */

// PayPal Popup Logic
const modal = document.getElementById('payModal');
const openBtn = document.querySelector('.open-btn');
const closeBtn = document.getElementById('closeBtn');
const headerWrapper = document.querySelector('.header-wrapper');

if (openBtn) {
  openBtn.onclick = () => {
    modal.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    headerWrapper?.classList.add('vp-active');
  }
}
function closeModal() {
  modal.classList.remove('active');
  document.documentElement.style.overflow = '';
  headerWrapper?.classList.remove('vp-active');
}
if (closeBtn) closeBtn.onclick = closeModal;

// Product URL Injection for Popup Forms
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('button.vp_popup').forEach(button => {
    button.addEventListener('click', function () {
      document.querySelector(".shopify-block.shopify-app-block")?.classList.add("active");
      document.querySelector(".header-wrapper")?.classList.add("vp-active");
      setTimeout(function () {
        const formEmbed = document.querySelector('form-embed#app-embed');
        if (formEmbed && formEmbed.shadowRoot) {
          const input = formEmbed.shadowRoot.querySelector('input#custom\\#product-link');
          if (input) input.value = window.location.href;
        }
      }, 600);
    });
  });
  $("#AZmZJdUg1ZVFLQnhEa__forms_inline_7MGRYD").on("click", function() {
    $(".shopify-block.shopify-app-block").removeClass("active");
    $(".header-wrapper").removeClass("vp-active");
  });
});

// Klarna Popup Logic
document.addEventListener("DOMContentLoaded", function () {
  const modals = document.querySelectorAll('.clara-modal');
  const openBtns = document.querySelectorAll('.clara-open-btn');
  const closeBtns = document.querySelectorAll('.clara-close');
  const closeFooterBtns = document.querySelectorAll('.clarna-close');

  openBtns.forEach((openBtn, index) => {
    openBtn.onclick = () => { modals[index].classList.add('active'); document.body.style.overflow = 'hidden'; };
    closeBtns[index].onclick = () => { modals[index].classList.remove('active'); document.body.style.overflow = ''; };
    closeFooterBtns[index].onclick = () => { modals[index].classList.remove('active'); document.body.style.overflow = ''; };
  });
});

/* =========================================================
   4. UI ELEMENTS: CAROUSELS, COUNTERS, SLIDERS
   Owl Carousel, Swiper, and Stats Counter logic.
   ========================================================= */
jQuery(document).ready(function(){
  jQuery(".owl-carousel").owlCarousel({
    loop: true, margin: 20, autoplay: true, items: 3,
    responsive:{ 0:{ items:1 }, 600:{ items:1 }, 1000:{ items:8 } }
  });

  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 2.5, spaceBetween: 20, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    breakpoints: { 0: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 1024: { slidesPerView: 2.5 } }
  });
  $('#btn1, #btn2, #btn3, #btn4').on('click', function () {
    swiper.slideTo(parseInt(this.id.replace('btn', ''), 10) - 1);
  });
});

// Stats Counter Animation
const counters = document.querySelectorAll('.counter');
counters.forEach(counter => {
  const updateCount = () => {
    const target = +counter.getAttribute('data-target');
    const count = +counter.innerText;
    const increment = target / 100;
    if (count < target) {
      counter.innerText = Math.ceil(count + increment);
      setTimeout(updateCount, 20);
    }
  };
  updateCount();
});

/* =========================================================
   5. GENERAL SITE SECURITY & UTILITIES
   Disable right-click, Share button, Lightbox.
   ========================================================= */
document.addEventListener("contextmenu", e => e.preventDefault());

$(document).ready(function () {
  $(".top-btn-share").on("click", e => { e.stopPropagation(); $(".top-sharebox").toggleClass("active"); });
  $(document).on("click", e => {
    if (!$(e.target).closest(".top-sharebox").length && !$(e.target).closest(".top-btn-share").length) {
      $(".top-sharebox").removeClass("active");
    }
  });
});

// Lightbox for Images
document.addEventListener("DOMContentLoaded", function () {
  const lightbox = document.getElementById("lightboxOverlay");
  const lightboxImage = document.querySelector(".lightbox-image");
  if (!lightbox) return;
  document.querySelectorAll(".custom-image-wrapper img").forEach(img => {
    img.addEventListener("click", () => { lightboxImage.src = img.src; lightbox.style.display = "flex"; });
  });
  document.querySelector(".lightbox-close")?.addEventListener("click", () => { lightbox.style.display = "none"; });
});

/* =========================================================
   6. YMQ APP LOGIC - PASSIVE TRIGGER & DESIGN
   ========================================================= */

// --- 6.1: PASSIVE POPUP STYLING ---
// We listen for the click but do NOT stop it. This lets YMQ open the popup.
$(document).on('click', '.ymq-option-title', function () {
  var $group = $(this).closest('.ymq-options-box').find('.spotlight-group');
  
  // We only add our class for styling purposes
  $('.spotlight-group').removeClass('vpactive');
  $group.addClass('vpactive');

  setTimeout(function () {
    if (!$group.find('.close-trigger').length) {
      $group.prepend('<div class="close-trigger">×</div>');
    }
    $('.header-wrapper').addClass('vp-header');
    $('html').addClass('hidden-flow');
  }, 100);
});

$(document).on('click', '.close-trigger, .vp-conform', function() {
  $('.spotlight-group').removeClass('vpactive');
  $('.header-wrapper').removeClass('vp-header');
  $('html').removeClass('hidden-flow');
});

// --- 6.2: ACCESSORY CARD DESIGN (40/60 Split) ---
function layoutAccessoryCard($item) {
  // If we already moved things, don't do it again
  if ($item.find('.vp-details-column').length) return;

  // 1. Create the 60% Width Detail Column
  $item.append('<div class="vp-details-column"></div>');
  var $details = $item.find('.vp-details-column');

  // 2. Identify elements
  var $title = $item.find('.ymq-canvas-text');
  var $price = $item.find('.ymq-price-in-option-value');
  var $qty = $item.find('.ymq-qty-input-wrappe-div');
  var $checkbox = $item.find('input[type="checkbox"], .ymq-checkbox');

  // 3. Move items in order: Title -> Divider -> Price -> Qty
  if ($title.length) $details.append($title);
  
  // Add the line division
  $details.append('<div class="vp-divider"></div>');
  
  if ($price.length) {
    // Ensure "Price:" label exists
    if (!$price.find('.pv-ymq-label').length) {
      $price.prepend('<span class="pv-ymq-label">Price: </span>');
    }
    $details.append($price);
  }
  
  if ($qty.length) $details.append($qty);

  // 4. Position the Checkbox Tick
  if ($checkbox.length) {
    $item.prepend('<div class="vp-selection-wrap"></div>');
    $item.find('.vp-selection-wrap').append($checkbox);
  }
}

jQuery(function ($) {
  function run() {
    $('.ymq-qty-input-item').each(function () { layoutAccessoryCard($(this)); });
  }
  // Run when app is likely loaded
  setTimeout(run, 1000);
  setTimeout(run, 3000);
});

/* CLOSE OPTIONS ONCE SELECTED */

document.addEventListener('click', function(e) {
    // 1. Check if the clicked element is one of the option buttons (labels)
    const label = e.target.closest('.ymq-canvas-box');
    
    if (label) {
        // 2. Check if this specific option has a quantity input nearby
        // Most 'no-qty' options in YMQ don't have the .ymq-qty-input-item-flex wrapper
        const hasQty = label.closest('.ymq-qty-input-item-flex');

        if (!hasQty) {
            // 3. Small delay (200ms) to let the app process the selection
            setTimeout(() => {
                // Find the close button/trigger (based on your inspect screenshot)
                const closeBtn = document.querySelector('.close-trigger, .ymq-options-close');
                if (closeBtn) {
                    closeBtn.click();
                }
            }, 200);
        }
    }
}, true);

/* =========================================================
   YMQ – Show SKU as Size in full-width row
   Uses input[data-sku]
========================================================= */

jQuery(function ($) {

  function addYmqSize($item) {
    var $input = $item.find('input[data-sku]').first();
    var sizeValue = $input.attr('data-sku');

    if (!sizeValue || sizeValue.trim() === '') return;

    $item.children('.vp-ymq-size-row').remove();

    var sizeHtml =
      '<div class="vp-ymq-size-row">' +
        '<span class="vp-ymq-size-label">Size:</span> ' +
        '<span class="vp-ymq-size-value">' + sizeValue + '</span>' +
      '</div>';

    var $details = $item.find('.vp-details-column').first();

    if ($details.length) {
      $details.after(sizeHtml);
    } else {
      $item.append(sizeHtml);
    }
  }

  function runYmqSize() {
    $('.ymq-options-qty-box .ymq-qty-input-item').each(function () {
      addYmqSize($(this));
    });
  }

  setTimeout(runYmqSize, 300);
  setTimeout(runYmqSize, 900);
  setTimeout(runYmqSize, 1600);
  setTimeout(runYmqSize, 2500);

  $(document).on('click change input', '.ymq-options-qty-box input', function () {
    setTimeout(runYmqSize, 100);
  });

  var target = document.querySelector('.ymq-options-qty-box');

  if (target) {
    var observer = new MutationObserver(function () {
      clearTimeout(window.__ymqSizeTimer);
      window.__ymqSizeTimer = setTimeout(runYmqSize, 100);
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

});